import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=772dce46&"
import script from "./OrganizationForm.vue?vue&type=script&lang=ts&"
export * from "./OrganizationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports